import { CSSProperties, memo } from "react";
import ListItem from "@mui/material/ListItem";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useConfirm } from "material-ui-confirm";
import { useNavigate } from "react-router-dom";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";
import { useDeleteTeamByIdMutation } from "entitites/teams/api/teamsApi";

interface ItemProps {
  style: CSSProperties;
  data: any;
  width: number;
}

export const TeamItem = memo(function ({ style, data, width }: ItemProps) {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { data: roles } = useGetMyRolesQuery();
  const [deleteIt] = useDeleteTeamByIdMutation();
  return (
    <ListItem
      secondaryAction={
        !Boolean(roles?.includes("staffdesk-admin")) ? (
          <Box display="flex" alignItems="center">
            <Box
              p={1}
              bgcolor="white"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
              fontSize="14px"
              fontWeight={400}
            >
              {data.users.length} уч.
            </Box>
            <Button
              disableElevation
              variant="contained"
              size="small"
              onClick={() =>
                navigate(`/teams/${data.id}/${window.location.search}`)
              }
              sx={{
                textTransform: "none",

                ml: "auto",
                fontWeight: 700,
              }}
            >
              Открыть
            </Button>
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              p={1}
              bgcolor="white"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
              fontSize="14px"
              fontWeight={400}
            >
              {data.users.length} уч.
            </Box>
            <ButtonGroup>
              <Button
                disableElevation
                variant="contained"
                size="small"
                onClick={() =>
                  navigate(`/teams/${data.id}/${window.location.search}`)
                }
              >
                +
              </Button>
              <Button
                disableElevation
                variant="contained"
                size="small"
                onClick={() =>
                  confirm()
                    .then(() => deleteIt(data.id))
                    .catch((err) => console.log(err))
                }
              >
                -
              </Button>
            </ButtonGroup>
          </Box>
        )
      }
      sx={{ ...style, ":first-of-type": { borderTop: "2px solid #DFDFFF" } }}
      key={data.id}
      disablePadding
    >
      <Box
        display="flex"
        alignItems="center"
        p={1}
        px={2}
        sx={{
          width: width,
          gap: 2,
          height: "100%",
          borderRadius: "0px",
          cursor: "default",
          borderBottom: "2px solid #DFDFFF",
        }}
      >
        <Box
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          width={width * 0.4}
          maxWidth={width * 0.4}
          fontSize="14px"
          fontWeight={600}
        >
          {data.name}
        </Box>
        <Box
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          width={width * 0.4}
          maxWidth={width * 0.4}
          fontSize="14px"
          fontWeight={400}
        >
          Руководитель команды: {data.teamLead.fio}
        </Box>
      </Box>
    </ListItem>
  );
});
